import { createStorage } from '@village/tools';

const storage = createStorage({ namespace: 'VMD_SCHEDULER', storage: localStorage });

export { storage };
